// extracted by mini-css-extract-plugin
export default {"inputWrapper":"TextInput_inputWrapper__BfPO0","textInput":"TextInput_textInput__7tZn4","labelWrapper":"TextInput_labelWrapper__zNjlZ"};